import './App.css';
import Live2d from './components/digitalHuman';
function App() {
  return (
    <div className="App">
      <video src={require('./assets/bg2.mp4')} autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', objectFit: 'fill' }} />
      <Live2d />
    </div>
  );
}

export default App;
